import { useCallback, useMemo, useState } from 'react';

/** The proposals ticked in one card, across its groups. */
export interface BiProposalSelection {
  selected: readonly string[];
  toggle: (draftId: string) => void;
  clear: () => void;
}

export function useBiProposalSelection(): BiProposalSelection {
  const [selected, setSelected] = useState<readonly string[]>([]);
  const toggle = useCallback(
    (draftId: string) =>
      setSelected(current =>
        current.includes(draftId)
          ? current.filter(id => id !== draftId)
          : [...current, draftId],
      ),
    [],
  );
  const clear = useCallback(() => setSelected([]), []);
  return useMemo(
    () => ({ selected, toggle, clear }),
    [selected, toggle, clear],
  );
}
